<template>
  <div>
    <as-dialogo
      ref="dialogoPesquisaCliente"
      title="Busca de Clientes"
      max-width="1440px"
      semPadding
    >
      <div slot="busca">
        <v-container grid-list-xs fluid pa-4 pb-0>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                label="Buscar Cliente"
                append-icon="search"
                @click:append="pesquisarCliente"
                @keydown.native.enter="pesquisarCliente"
                v-model="busca_cliente"
                autofocus
                solo
                background-color="grey lighten-2"
                placeholder="Digite o código, nome fantasia, razão social, CNPJ/CPF ou nome do responsável"
                ref="busca_clientes"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-container fluid pa-4 pt-0>
        <v-data-table
          :headers="headers_clientes"
          :items="clientes"
          item-key="id"
          show-expand
          single-expand
          :expanded.sync="expanded"
          :footer-props="{
            itemsPerPageOptions: [30, 50, 10, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
          v-show="!loading_busca_clientes"
          @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
          class="row-pointer"
          :search="busca_cliente"
          :custom-filter="filtrarClientes"
        >
          <template v-slot:item.id="{ item }">
            <td :inner-html.prop="String(item.id) | highlight(busca_cliente)" />
          </template>
          <template v-slot:item.nome="{ item }">
            <td :inner-html.prop="item.nome | highlight(busca_cliente)" />
          </template>
          <template v-slot:item.responsavel_nome="{ item }">
            <td
              :inner-html.prop="
                item.responsavel_nome | highlight(busca_cliente)
              "
            />
          </template>

          <template v-slot:item.lojas="{ item }">
            {{ item.lojas.length }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-4">
              <v-data-table
                :items="item.lojas"
                item-key="id"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th style="width: '30%'; text-align: left;">
                        Nome Fantasia
                      </th>
                      <th style="width: '35%'; text-align: left;">
                        Razão Social
                      </th>
                      <th style="width: '30%'; text-align: left;">CNPJ</th>
                      <th style="width: '5%'; text-align: right;">Local</th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item }">
                  <tr @click="selecionarCliente(item)" style="cursor: pointer">
                    <td
                      style="width: '30%'; text-align: left;"
                      :inner-html.prop="
                        item.nome_fantasia | highlight(busca_cliente)
                      "
                    />

                    <td
                      style="width: '35%'; text-align: left;"
                      :inner-html.prop="
                        item.razao_social | highlight(busca_cliente)
                      "
                    />

                    <td
                      style="width: '30%'; text-align: left;"
                      :inner-html.prop="item.cnpj | highlight(busca_cliente)"
                    />

                    <td
                      style="width: '5%'; text-align: right;"
                      :inner-html.prop="
                        `${item.endereco.cidade} / ${item.endereco.estado}`
                          | highlight(busca_cliente)
                      "
                    />
                  </tr>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>

        <v-layout
          v-show="loading_busca_clientes"
          class="justify-center align-center my-5"
        >
          <v-progress-circular
            indeterminate
            size="50"
            width="3"
            color="primary"
          ></v-progress-circular>
        </v-layout>
      </v-container>
    </as-dialogo>
  </div>
</template>

<script>
import ServicePedidos from "@/services/pedidos.js";

export default {
  name: "BuscaClientes",
  data() {
    return {
      busca_cliente: "",
      loading_busca_clientes: false,
      rodada: {},
      user: {},
      headers_clientes: [
        {
          text: "Código",
          value: "id",
          width: "10%",
          align: "center",
          sortable: true,
        },
        {
          text: "Empresa / Grupo de Empresas",
          value: "nome",
          width: "40%",
          align: "left",
          sortable: true,
        },
        {
          text: "Responsável",
          value: "responsavel_nome",
          width: "40%",
          align: "left",
          sortable: true,
        },
        {
          text: "Lojas",
          value: "lojas",
          width: "5%",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "data-table-expand",
          width: "5%",
          align: "left",
          sortable: false,
        },
        {
          text: "CNPJs",
          value: "cnpjs",
          align: " d-none",
        },
      ],
      headers: [
        {
          text: "Código",
          value: "codigo",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "Descrição",
          value: "descricao",
          width: "55%",
          align: "left",
          sortable: false,
        },
        {
          text: "Quantidade",
          value: "quantidade",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "Preço",
          value: "valor",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "Subtotal",
          value: "subtotal",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "acoes",
          width: "5%",
          align: "center",
          sortable: false,
        },
      ],
      expanded: [],
      clientes: [],
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
  },
  methods: {
    filtrarClientes(value, query, item) {
      if (!query) return true;

      const obj = [item.id, item.responsavel_nome, item.nome];

      item.lojas.forEach((it) => {
        obj.push(it.razao_social);
        obj.push(it.nome_fantasia);
        obj.push(it.cnpj);
        obj.push(it.endereco.cidade);
      });

      const result = obj
        .join("|")
        .toLocaleLowerCase()
        .includes(query.toLocaleLowerCase());

      if (result) this.expanded.push(item);

      return result;
    },
    abrir() {
      this.busca_cliente = "";
      this.expanded = [];
      this.$refs.dialogoPesquisaCliente.abrir();
      this.pesquisarCliente();
      setTimeout(() => {
        this.$refs.busca_clientes.focus();
      }, 500);
    },
    async pesquisarCliente() {
      try {
        this.loading_busca_clientes = true;

        const id =
          String(parseInt(this.busca_cliente, 10)) ===
          this.busca_cliente?.trim()
            ? parseInt(this.busca_cliente, 10)
            : null;

        let clientes = "";
        if (this.busca_cliente) {
          clientes = await ServicePedidos.getClientes(
            this.rodada.id,
            id ? id : null,
            !id ? this.busca_cliente : null
          );
        } else {
          clientes = await ServicePedidos.getClientes(this.rodada.id, "");
        }
        this.clientes = clientes.data.clientes.map((cli) => ({
          ...cli,
          cnpjs: cli.lojas.map((cli2) => cli2.cnpj).join(","),
        }));
      } catch (error) {
        this.$eventbus.erro("Erro ao fazer a busca de clientes", error);
      } finally {
        this.loading_busca_clientes = false;
      }
    },
    selecionarCliente(cliente) {
      this.$emit("selecionouCliente", this.clone(cliente));
      this.$refs.dialogoPesquisaCliente.fechar();
    },
  },
  watch: {
    busca_cliente: function(value) {
      if (!value || !value.trim()) {
        if (this.expanded.length > 0) {
          this.expanded = [];
        }
      }
    },
  },
};
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
